import React, { MutableRefObject, useContext, useEffect, useState } from 'react';
import { Box, Button, Divider, Drawer, IconButton, List, ListItem, ListItemText, Toolbar, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useStyles } from './styles';
import logo from '../../../../Assets/images/ideabaaz.svg';
import { useLocation, useNavigate } from 'react-router-dom';
import routes from '../../../../Utils/routes';
import { AuthContext } from '../../../../Helpers/Contexts/authContext';
import CloseIcon from '@mui/icons-material/Close';
import MenuIcon from '@mui/icons-material/Menu';

const navLinks = [
  'Home',
  'About',
  //  'How It Works',
  'FAQs',
];

interface NavBarProps {
  aboutRef: MutableRefObject<HTMLDivElement | null>;
  HIWRef: MutableRefObject<HTMLDivElement | null>;
  FAQRef: MutableRefObject<HTMLDivElement | null>;
  HomeRef: MutableRefObject<HTMLDivElement | null>;
}

const Navbar: React.FC<NavBarProps> = ({ aboutRef, HIWRef, FAQRef, HomeRef }) => {
  const {
    state: { isAuthenticated },
  } = useContext(AuthContext);
  const classes = useStyles();
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);
  const [shouldScrollToTop, setShouldScrollToTop] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const location = useLocation();
  const [drawerOpen, setDrawerOpen] = useState(false);

  useEffect(() => {
    const container = document.getElementById('scroll-container') || window;

    const handleScroll = () => {
      let scrollTop = 0;

      if (container instanceof Window) {
        scrollTop = container.scrollY;
      } else if (container instanceof HTMLElement) {
        scrollTop = container.scrollTop;
      }

      if (location.pathname === '/') {
        if (isMobile) {
          setScrolled(scrollTop > 580);
        } else {
          setScrolled(scrollTop > 800);
        }
      } else {
        setScrolled(scrollTop > 0);
      }
    };

    if (container) {
      container.addEventListener('scroll', handleScroll);
    }

    return () => {
      if (container) {
        container.removeEventListener('scroll', handleScroll);
      }
    };
  }, [isMobile, location.pathname]);

  useEffect(() => {
    if (shouldScrollToTop && location.pathname === '/') {
      const container = document.getElementById('scroll-container');
      if (container) {
        container.scrollTo({ top: 0, behavior: 'smooth' });
      } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
      setShouldScrollToTop(false);
    }
  }, [location.pathname, shouldScrollToTop]);

  const handleNavClick = (link: string) => {
    if (link === 'About' && aboutRef.current) {
      aboutRef.current.scrollIntoView({ behavior: 'smooth' });
    } else if (link === 'How It Works' && HIWRef.current) {
      HIWRef.current.scrollIntoView({ behavior: 'smooth' });
    } else if (link === 'FAQs' && FAQRef.current) {
      FAQRef.current.scrollIntoView({ behavior: 'smooth' });
    } else if (link === 'Home' && HomeRef.current) {
      HomeRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleLogoClick = () => {
    if (location.pathname === '/') {
      const container = document.getElementById('scroll-container');
      if (container) {
        container.scrollTo({ top: 0, behavior: 'smooth' });
      } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    } else {
      setShouldScrollToTop(true);
      navigate('/');
    }
  };

  // if (isMobile && scrolled) return null;

  return (
    <Box className={classes.navBar}>
      <Box className={`${classes.appbar} ${classes.appbarScrolled}`}>
        <Toolbar className={`${classes.toolBar} ${classes.toolBarScrolled}`}>
          <Box className={classes.LogoContainer} onClick={handleLogoClick}>
            <img src={logo} alt="Ideabaaz Logo" className={classes.Logo} />
          </Box>
          {/* <Button className={classes.ApplyNowBtn} >
            Coming Soon!
          </Button> */}
          {!isMobile ? (
            <Box className={classes.navLinks}>
              {navLinks.map((navLink, idx) => (
                <Typography
                  key={idx}
                  className={classes.navLink}
                  onClick={() => {
                    handleNavClick(navLink);
                  }}
                >
                  {navLink}
                </Typography>
              ))}
              {/* <P47Button onClick={() => navigate(isAuthenticated ? routes.home : routes.login)} title={isAuthenticated ? 'Dashboard' : 'Apply Now'} /> */}
              <Button
                className={classes.SubmitNowBtn}
                sx={{
                  mt: 'auto',
                  alignSelf: 'flex-start',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 1,
                  px: 2.5,
                  py: 2,
                  fontSize: 14,
                  fontWeight: 400,
                  borderRadius: 2,
                  maxWidth: '100%',
                  background: 'rgba(255,255,255,1) !important',
                  color: '#E1490B !important',
                  border: '1px solid #B73601 !important',
                  boxShadow: '0px 1px 2px 0px rgba(183,54,1,0.3), 0px 0px 0px 2px rgba(183,54,1,0.16) !important',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  '&:hover': {
                    backgroundColor: 'rgba(255,255,255,0.9) !important',
                    background: 'rgba(255,255,255,0.9) !important',
                  },
                }}
                onClick={() => window.open('https://www.ideabaazdangal.com/register', '_blank')}
              >
                {/* {isAuthenticated ? 'Dashboard' : 'Startup? - Register Here'} */}
                Register your idea
                <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M4.75 4.42578C4.05964 4.42578 3.5 4.98543 3.5 5.67578V12.1758C3.5 12.8661 4.05964 13.4258 4.75 13.4258H11.25C11.9404 13.4258 12.5 12.8661 12.5 12.1758V10.6758C12.5 10.2616 12.8358 9.92578 13.25 9.92578C13.6642 9.92578 14 10.2616 14 10.6758V12.1758C14 13.6946 12.7688 14.9258 11.25 14.9258H4.75C3.23122 14.9258 2 13.6946 2 12.1758V5.67578C2 4.157 3.23122 2.92578 4.75 2.92578H6.25C6.66421 2.92578 7 3.26157 7 3.67578C7 4.08999 6.66421 4.42578 6.25 4.42578H4.75ZM7.99976 3.67578C7.99976 3.26157 8.33554 2.92578 8.74976 2.92578H13.2498C13.664 2.92578 13.9998 3.26157 13.9998 3.67578V8.17578C13.9998 8.58999 13.664 8.92578 13.2498 8.92578C12.8355 8.92578 12.4998 8.58999 12.4998 8.17578V5.48673L9.28008 8.70634C8.98719 8.99924 8.51231 8.99923 8.21942 8.70634C7.92653 8.41344 7.92653 7.93857 8.21943 7.64568L11.4394 4.42578H8.74976C8.33554 4.42578 7.99976 4.08999 7.99976 3.67578Z"
                    fill="#B73601"
                  />
                </svg>
              </Button>
              <Button className={classes.ApplyNowBtn} onClick={() => navigate('/signup?applicationName=ideaBaaz')}>
                Register your startup{' '}
                <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M4.75 4.42578C4.05964 4.42578 3.5 4.98543 3.5 5.67578V12.1758C3.5 12.8661 4.05964 13.4258 4.75 13.4258H11.25C11.9404 13.4258 12.5 12.8661 12.5 12.1758V10.6758C12.5 10.2616 12.8358 9.92578 13.25 9.92578C13.6642 9.92578 14 10.2616 14 10.6758V12.1758C14 13.6946 12.7688 14.9258 11.25 14.9258H4.75C3.23122 14.9258 2 13.6946 2 12.1758V5.67578C2 4.157 3.23122 2.92578 4.75 2.92578H6.25C6.66421 2.92578 7 3.26157 7 3.67578C7 4.08999 6.66421 4.42578 6.25 4.42578H4.75ZM7.99976 3.67578C7.99976 3.26157 8.33554 2.92578 8.74976 2.92578H13.2498C13.664 2.92578 13.9998 3.26157 13.9998 3.67578V8.17578C13.9998 8.58999 13.664 8.92578 13.2498 8.92578C12.8355 8.92578 12.4998 8.58999 12.4998 8.17578V5.48673L9.28008 8.70634C8.98719 8.99924 8.51231 8.99923 8.21942 8.70634C7.92653 8.41344 7.92653 7.93857 8.21943 7.64568L11.4394 4.42578H8.74976C8.33554 4.42578 7.99976 4.08999 7.99976 3.67578Z"
                    fill="white"
                  />
                </svg>
              </Button>
            </Box>
          ) : (
            <>
              <IconButton onClick={() => setDrawerOpen(true)} edge="end">
                <MenuIcon sx={{ color: 'white' }} />
              </IconButton>
              <Drawer anchor="right" open={drawerOpen} onClose={() => setDrawerOpen(false)}>
                <Box sx={{ width: 280 }}>
                  <Box display="flex" justifyContent="space-between" alignItems="center" p={2}>
                    <Typography variant="h6"></Typography>
                    <IconButton onClick={() => setDrawerOpen(false)}>
                      <CloseIcon />
                    </IconButton>
                  </Box>
                  <Divider />
                  <List>
                    {navLinks.map((link, index) => (
                      <ListItem
                        button
                        key={index}
                        onClick={() => {
                          handleNavClick(link);
                          setDrawerOpen(false);
                        }}
                      >
                        <ListItemText primary={link} />
                      </ListItem>
                    ))}
                  </List>
                  <Box sx={{ p: 2, pt: 1 }}>
                    <Box
                      onClick={() => {
                        window.open('https://www.ideabaazdangal.com/register', '_blank');
                        setDrawerOpen(false);
                      }}
                      sx={{
                        width: '100%',
                        mb: 2,
                        backgroundColor: '#1b1957',
                        color: 'white',
                        padding: '10px 2px',
                        borderRadius: '4px',
                        textAlign: 'center',
                        cursor: 'pointer',
                        fontWeight: 500,
                        fontSize: '0.875rem',
                      }}
                    >
                      {/* {isAuthenticated ? 'Dashboard' : 'Startup? - Register Here'} */}
                      Register your idea
                    </Box>
                    <Button
                      variant="contained"
                      onClick={() => {
                        navigate('/signup?applicationName=ideaBaaz');
                        setDrawerOpen(false);
                      }}
                      sx={{
                        width: '100%',
                        backgroundColor: '#28a745',
                        '&:hover': {
                          backgroundColor: '#218838',
                        },
                      }}
                    >
                      Register your startup{' '}
                    </Button>
                  </Box>
                </Box>
              </Drawer>
            </>
          )}
          {/* <Button className={classes.ApplyNowBtn} onClick={() => navigate(routes.login)}>
            {isAuthenticated ? 'Dashboard' : 'Register Now'}
          </Button> */}
        </Toolbar>
      </Box>
    </Box>
  );
};

export default Navbar;
